/** Le vocabulaire du chiffrage, partagé par les écrans du poste. */

export const TVA = [
  { valeur: 0, libelle: 'Pas de TVA' },
  { valeur: 3, libelle: '3 %' },
  { valeur: 6, libelle: '6 %' },
  { valeur: 16, libelle: '16 %' },
  { valeur: 17, libelle: '17 % — Luxembourg' },
  { valeur: 20, libelle: '20 %' },
  { valeur: 21, libelle: '21 % — Belgique' },
];

export const ORIGINES = [
  { valeur: '1', libelle: 'Bâtiment' },
  { valeur: '2', libelle: 'Pertes indirectes' },
  { valeur: '3', libelle: 'Perte financière' },
  { valeur: '4', libelle: 'Frais de gestion' },
  { valeur: '5', libelle: 'Frais de logement provisoire' },
  { valeur: '6', libelle: 'Frais de chômage immobilier' },
  { valeur: '7', libelle: "Frais d'expertise" },
  { valeur: '8', libelle: 'Frais administratifs' },
  { valeur: '9', libelle: 'Autres frais' },
];

export const UNITES = [
  { valeur: 'h', libelle: 'h' },
  { valeur: 'm', libelle: 'm' },
  { valeur: 'm2', libelle: 'm²' },
  { valeur: 'm3', libelle: 'm³' },
  { valeur: '%', libelle: '%' },
  { valeur: 'unit', libelle: 'unité' },
  { valeur: 'forfait', libelle: 'forfait' },
  { valeur: 'km', libelle: 'km' },
];

const CONNUES = new Set(UNITES.map((u) => u.valeur));

const EQUIVALENTS = {
  heure: 'h', heures: 'h', hr: 'h',
  metre: 'm', mètre: 'm',
  'm²': 'm2', 'm carre': 'm2', 'metre carre': 'm2', 'mètre carré': 'm2',
  'm³': 'm3', 'metre cube': 'm3', 'mètre cube': 'm3',
  unite: 'unit', unité: 'unit', unites: 'unit', unités: 'unit',
  pièce: 'unit', piece: 'unit',
  pourcent: '%', 'pour cent': '%',
  kilometre: 'km', kilomètre: 'km',
};

/**
 * Ramène l'unité du barème à l'une de celles que l'écran sait afficher.
 *
 * Le barème contient des unités écrites à la main : sans ce passage, la liste
 * déroulante tombait sur une valeur qu'elle ne connaît pas, s'affichait vide,
 * et enregistrait une unité que le rapport ne saurait pas rendre.
 */
export function unitePropre(brute) {
  if (!brute) return 'forfait';
  const v = String(brute).trim().toLowerCase();
  if (CONNUES.has(v)) return v;
  return EQUIVALENTS[v] || 'forfait';
}

export const nombre = (v) => {
  if (v === null || v === undefined || v === '') return 0;
  const n = Number(String(v).replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
};

export const euros = (montant) => new Intl.NumberFormat('fr-BE', {
  style: 'currency', currency: 'EUR',
}).format(nombre(montant));

export const libelleOrigine = (valeur) =>
  ORIGINES.find((o) => o.valeur === String(valeur))?.libelle || '—';

export const libelleTva = (valeur) =>
  TVA.find((t) => t.valeur === Number(valeur))?.libelle || `${valeur} %`;

export const OUTILS_QUILL = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' },
     { indent: '-1' }, { indent: '+1' }],
    ['clean'],
  ],
};

export const FORMATS_QUILL = [
  'header', 'font', 'size', 'bold', 'italic', 'underline', 'strike',
  'blockquote', 'list', 'bullet', 'indent',
];
